module.exports = __webpack_public_path__ + "img/star-half-wide.e8a9ca34.svg";